export default __webpack_public_path__ + "static/media/Fabien.6c126849.jpg";